import { render, staticRenderFns } from "./deptBudget.vue?vue&type=template&id=63f8cb7c&scoped=true"
import script from "./deptBudget.vue?vue&type=script&lang=js"
export * from "./deptBudget.vue?vue&type=script&lang=js"
import style0 from "./deptBudget.vue?vue&type=style&index=0&id=63f8cb7c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f8cb7c",
  null
  
)

export default component.exports